import * as OvationsApi from 'core/ovations-api';

export const mockPortalFAQSectionItem: OvationsApi.Types.PortalFAQSectionItem = {
    id: 10,
    title: '_mockSectionItemTitle_',
    responseText: '_mockResponseText_',
};

export const mockPortalFAQSection: OvationsApi.Types.PortalFAQSection = {
    id: 1,
    title: '_mockSectionTitle_',
    items: [mockPortalFAQSectionItem, { ...mockPortalFAQSectionItem, id: 20 }, { ...mockPortalFAQSectionItem, id: 30 }],
};

export const mockPortalFAQ: OvationsApi.Types.PortalFAQ = {
    programId: '__programId__',
    faqSections: [mockPortalFAQSection],
};
